/**
 * Prefix the modal writes in front of a free-text answer, e.g. `"Other I saw a
 * sign"`. Kept here so reading and writing stay in sync.
 */
const OTHER_ANSWER_PREFIX = "Other ";

const howDidYouHeardOptionBaseValues = {
  TV: false,
  Billboard: false,
  "Mail or flyer": false,
  "Online search": false,
  "News or blog article": false,
  "Online ad": false,
  "Friend, family, or colleague": false,
  "Social media": false,
  "Attended an event in a Peerspace": false,
  "Contacted by Peerspace": false,
  "Referral from a Peerspace host": false,
  Other: false,
  otherDetail: "",
};

export {howDidYouHeardOptionBaseValues, OTHER_ANSWER_PREFIX}